import styled from "styled-components";

export const BimbelModalStudentTitle = styled.p`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
`;

export const BimbelModalTitle = styled.h1`
  font-weight: 700;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes["3xl"]};
  text-align: center;
  color: ${({ theme }) => theme.colors.yellow["500"]};
`;

export const BimbelModalSubTitle = styled.p`
  font-weight: 400;
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
`;

export const BimbelModalButtonContainer = styled.div`
  text-align: center;
  position: fixed;
  left: 50%;
  transform: translate(-50%, 0%);
  z-index: 999999;
`;

export const CocoBimbelModalContainer = styled.div`
  position: relative;
  margin-top: -130px;
  bottom: -37px;
`;

export const LightRaysModal = styled.div`
  position: relative;
  bottom: 20px;
  object-fit: cover;
`;
export const BimbelModal = styled.div`
  transform: translate(2%, 18%) scale(1.2, 1.2);
  position: relative;
`;
